// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Dkal","name":"styles_name__LTGyA","phone":"styles_phone__2bsZD"};